"use client";

import { useEffect, useState } from 'react';

/**
 * Componente cliente para lidar com comportamentos específicos do navegador
 * e evitar erros de hidratação no RootLayout.
 */
export function ClientLayout({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    // 1. Bloqueio do Zoom em Pinça (Pinch-to-zoom) para feeling de app nativo
    const handleTouchMove = (event: TouchEvent) => {
      // @ts-ignore
      if (event.scale !== undefined && event.scale !== 1) {
        event.preventDefault();
      }
    };

    // 2. Prevenção de comportamentos de scroll elástico excessivo
    document.body.style.overscrollBehaviorY = 'none';

    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.body.style.overscrollBehaviorY = 'auto';
    };
  }, []);

  // Evita mismatch de hidratação renderizando apenas após montagem no cliente
  if (!mounted) {
    return <div className="min-h-screen bg-background" />;
  }

  return <>{children}</>;
}
